/* eslint-disable no-unused-vars */
import React, { useState } from "react"
import { Box, Button } from "@material-ui/core"
import { Page, PageSection, SearchBar } from "src/components"
import SuspenseWrapper from "src/components/layout/SuspenseWrapper"
import UsersDataTable from "./components/UsersDataTable"

const UserAdminPage = () => {
  const [isAddDialogOpen, setIsAddDialogOpen] = useState(false)

  return (
    <>
      <Page title="User Management">
        <SearchBar name="User" disabled mb={3} />
        <Box display="flex" justifyContent="flex-end" mb={2}>
          <Button
            color="primary"
            variant="contained"
            onClick={() => setIsAddDialogOpen(true)}
          >
            Add User
          </Button>
        </Box>
        <PageSection>
          <Box sx={{ pt: 3 }}>
            <SuspenseWrapper>
              <UsersDataTable
                isAddDialogOpen={isAddDialogOpen}
                onCloseAddDialog={() => setIsAddDialogOpen(false)}
              />
            </SuspenseWrapper>
          </Box>
        </PageSection>
      </Page>
    </>
  )
}

UserAdminPage.propTypes = {}

export default UserAdminPage
